import * as yup from 'yup';
import { MAX_FILE_SIZE } from './constants';

export const validationSchema = yup.object().shape({
    title: yup.string().required('Title is required'),
    // description: yup.string().required('Description is required'),
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Enter a valid email').required('Email is required'),
    scheduledDateTime: yup.string().required('Date is required'),
    //houseDescription: yup.string().required('House description is required'),
    address: yup
        .object()
        .shape({
            description: yup.string(),
            placeId: yup.string(),
        })
        .required('Address is required')
        .nullable(),
    phoneNumber: yup
        .string()
        .min(10, 'Phone number should contain 10 characters length')
        .required('Phone number is required'),
    attachments: yup.array().of(
        yup.object().shape({
            file: yup
                .mixed()
                .test('is-valid-size', 'Max allowed size is 5MB', (value) =>
                    value ? (value as { size: number }).size <= MAX_FILE_SIZE : true,
                ),
        }),
    ),
});
